import React, { useCallback, useEffect } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state";
import { MutateTPMSConfig } from "../../../../utils/graphql/hooks/TPMSHooks";
import toast from "react-hot-toast";

interface EditTyreDialogProps {
  isOpen: boolean;
  showDialog: (newState: boolean) => void;
  selectedSensorId: string;
  group: string | null;
}

function shake() {
  const dialog = document.getElementsByClassName("dialog");
  if (dialog.length > 0) {
    for (const el of dialog) {
      el.classList.add(styles.shaking);
      setTimeout(() => {
        el.classList.remove(styles.shaking, styles.shouldGrow);
      }, 500);
    }
  }
}

export default function EditTyreDialog(props: EditTyreDialogProps) {
  const { isOpen, showDialog, selectedSensorId, group } = props;
  const selectedCar = useSelector(
    (state: RootState) => state.tpms.selectedCar,
  ) as string;
  const tpmsConfig = useSelector((state: RootState) => state.tpms.tpmsConfig);
  const updateTPMSConfig = MutateTPMSConfig();

  const tyreConfig = React.useMemo(
    () => (tpmsConfig ? tpmsConfig.tyres : []),
    [tpmsConfig],
  );
  const isFront = group?.toLowerCase() === "front" ? true : false;

  const tyreIDElement = document.getElementById(
    `TyreIDEditInput${group}`,
  ) as HTMLInputElement;
  const sensorIDElement = document.getElementById(
    `SensorIDEditInput${group}`,
  ) as HTMLInputElement;

  const closeDialog = useCallback(() => {
    if (tyreIDElement) tyreIDElement.value = "";
    if (sensorIDElement) sensorIDElement.value = "";
    showDialog(false);
  }, [tyreIDElement, sensorIDElement, showDialog]);

  useEffect(() => {
    if (selectedSensorId) {
      const thisTyre = tyreConfig.find((x) => x.sensorId === selectedSensorId);
      const tyreId = thisTyre?.tyreId;
      const sensorId = thisTyre?.sensorId;
      if (sensorId && tyreId) {
        sensorIDElement.value = sensorId;
        tyreIDElement.value = tyreId;
      } else {
        closeDialog();
      }
    }
  }, [
    closeDialog,
    isOpen,
    selectedSensorId,
    sensorIDElement,
    tyreConfig,
    tyreIDElement,
  ]);

  function submitTyre(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();

    const oldTyreIdx = tyreConfig.findIndex(
      (x) => x.sensorId === selectedSensorId,
    );

    const tyreId = tyreIDElement.value;
    const sensorId = sensorIDElement.value;

    if (oldTyreIdx && tyreId && sensorId) {
      const thisTyreObj = {
        carId: selectedCar,
        tyreId: tyreId,
        sensorId: sensorId,
        isFront: isFront,
      };

      console.log("EDIT", thisTyreObj);

      const newTyreConfig = structuredClone(tyreConfig);
      newTyreConfig[oldTyreIdx] = thisTyreObj;

      updateTPMSConfig({
        variables: {
          tyres: newTyreConfig,
        },
      })
        .then(() => {
          closeDialog();
        })
        .catch((e) => {
          const errMsg = e.graphQLErrors[0].message;
          toast.error(errMsg);
          shake();
        });
    } else {
      shake();
    }
  }

  return (
    <div
      style={!isOpen ? { display: "none" } : {}}
      className={styles.dialogContainer}
    >
      <div className={`${styles.dialog} ${styles.shouldGrow} dialog`}>
        <div className={styles.title}>
          Edit {group} Tyre - Car {selectedCar}
        </div>
        <form>
          <div>
            <p>
              <label>Tyre ID:</label>
              <input id={`TyreIDEditInput${group}`} type="text" autoFocus />
            </p>
            <p>
              <label>Sensor ID:</label>
              <input id={`SensorIDEditInput${group}`} type="number" />
            </p>
            <p></p>
          </div>
          <div>
            <button className={styles.submitButton} onClick={submitTyre}>
              Submit
            </button>
          </div>
        </form>
      </div>
      <div
        className={styles.backgroundBlur}
        onClick={() => closeDialog()}
      ></div>
    </div>
  );
}
